module.exports = __webpack_public_path__ + "static/media/funnel_data_sample_mobile_en.3615f3fc.png";